import { render, staticRenderFns } from "./ScoreCard.vue?vue&type=template&id=ee830e5c&scoped=true"
import script from "./ScoreCard.vue?vue&type=script&lang=js"
export * from "./ScoreCard.vue?vue&type=script&lang=js"
import style0 from "./ScoreCard.vue?vue&type=style&index=0&id=ee830e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee830e5c",
  null
  
)

export default component.exports